
export default (https) => ({
  async getList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/suppliers?${queryString}`);
    return response.data;
  },
  async add(payload) {
    const response = await https.post(`/suppliers`, payload);
    return response.data;
  },




  async update(id, payload) {
    console.log(payload,'payload')
    const response = await https.put(`/suppliers/${id}`, payload);
    return response.data;
  },

  async deleteById(id) {
    const response = await https.delete(`/suppliers/${id}`);
    return response.data;
  },
});
